import { PayloadV2 } from '../../../../../core/service/payload/payloadV2';
import { Payload } from '../../../../../core/service/payload/payload';
import { Moment } from 'moment';
import { MessageCreatePayload } from '../../../../../message/impl/service/payload/messageCreate.payload';

export class WorkflowTaskHumanSavePayload implements Payload {

    assignedUserId: number;
    deadline: Moment;
    title: string;
    statusValue: string;
    message: MessageCreatePayload;
    initialMessageContentToUpdate: string;
}
